(function () {
  function initCarousel(carousel) {
    var track = carousel.querySelector('[data-lp-carousel-track]');
    var thumbs = carousel.querySelectorAll('[data-thumb-index]');
    var prevBtn = carousel.querySelector('[data-lp-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-lp-carousel-next]');
    var slides = track ? track.querySelectorAll('.lp-offer-cta__carousel-slide') : [];

    if (!track || slides.length === 0) return;

    var activeIndex = 0;

    function goToSlide(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      activeIndex = index;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goToSlide(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(activeIndex + 1);
      });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var trackLeft = track.scrollLeft;
        var trackWidth = track.clientWidth;
        var center = trackLeft + trackWidth / 2;
        for (var i = 0; i < slides.length; i++) {
          var slide = slides[i];
          if (slide.offsetLeft <= center && slide.offsetLeft + slide.offsetWidth > center) {
            if (i !== activeIndex) {
              activeIndex = i;
              thumbs.forEach(function (t, j) {
                t.classList.toggle('is-active', j === i);
              });
            }
            break;
          }
        }
      }, 100);
    });

    goToSlide(0);
  }

  function initAll() {
    document.querySelectorAll('[data-lp-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    var carousels = section.querySelectorAll('[data-lp-carousel]');
    carousels.forEach(initCarousel);
  });
})();
